export default __webpack_public_path__ + "static/media/easy-dificulty.bc86fc36.svg";